// roles.js
const getUser = () => JSON.parse(localStorage.getItem('user'))

export const isAdmin = () => {
  const user = getUser()
  return user && user.grp === 'admin'
}

export const isUser = () => {
  const user = getUser()
  return user && user.grp === 'user'
}

export const isWatchdog = () => {
  const user = getUser()
  return user && user.grp === 'watchdog'
}
